import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#003366] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">KayaClean</h3>
            <p className="text-slate-300 mb-4">
              Gebäudedienstleister
            </p>
            <p className="text-slate-300 text-sm leading-relaxed">
              Professionelle Gebäudereinigung für Unternehmen. Zuverlässig, strukturiert und hochwertig.
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Kontakt</h4>
            <div className="space-y-3">
              <p className="text-slate-300 flex items-start gap-3">
                <span className="text-[#00BFFF] font-medium">Kontaktperson:</span>
              </p>
              <p className="text-white">Sinan Kaya</p>
              <a
                href="tel:+4916092653278"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4 text-[#00BFFF]" />
                +49 160 92653278
              </a>
              <a
                href="mailto:fa.kayaclean@gmail.com"
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 text-[#00BFFF]" />
                fa.kayaclean@gmail.com
              </a>
            </div>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Rechtliches</h4>
            <div className="space-y-3">
              <Link
                to="/impressum"
                className="block text-slate-300 hover:text-white transition-colors"
                data-testid="footer-impressum"
              >
                Impressum
              </Link>
              <Link
                to="/datenschutz"
                className="block text-slate-300 hover:text-white transition-colors"
                data-testid="footer-datenschutz"
              >
                Datenschutzerklärung
              </Link>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-slate-600">
          <p className="text-center text-slate-400 text-sm">
            © {new Date().getFullYear()} KayaClean Gebäudedienstleister. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
